import { render, staticRenderFns } from "./addSeal.vue?vue&type=template&id=afa225c0&scoped=true"
import script from "./addSeal.vue?vue&type=script&lang=js"
export * from "./addSeal.vue?vue&type=script&lang=js"
import style0 from "./addSeal.vue?vue&type=style&index=0&id=afa225c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa225c0",
  null
  
)

export default component.exports